import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gfu-progress-overlay__inner" }
const _hoisted_2 = {
  key: 0,
  class: "gfu-progress-overlay__message"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-progress-overlay', $options.classes]),
    "data-qa": "progress-overlay"
  }, [
    _createElementVNode("div", _hoisted_1, [
      ($props.message)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.message), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ])
  ], 2 /* CLASS */))
}